import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useWidgetHost, useWidgetState} from '../../../../../hooks/state-provider'
import {getDaysInMonthWithEvents, getReferenceMonth} from '../../../../../selectors/calendar-layout'
import {getBorderStyle} from '../../../../../utils/calendar'
import sc from '../../../../classes.scss'
import {MobileMonthlyDay} from './day'
import s from './mobile-monthly-days.scss'

export const MobileMonthlyDays = () => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()

  const referencedMonth = useWidgetState(getReferenceMonth)
  const days = useWidgetState(state => getDaysInMonthWithEvents(state, referencedMonth))
  const host = useWidgetHost()
  const borderStyleTop = getBorderStyle({host}, 'top')
  const borderStyleBottom = getBorderStyle({host}, 'bottom')
  const mobileCalendarRewireEnabled = experiments.enabled(ExperimentNames.MobileCalendarRewire)

  return (
    <div
      className={classNames(s.days, {[s.rewire]: mobileCalendarRewireEnabled})}
      style={mobileCalendarRewireEnabled ? undefined : borderStyleTop}
    >
      {days.length ? (
        days.map(day => (
          <div key={day} className={s.day} style={mobileCalendarRewireEnabled ? undefined : borderStyleBottom}>
            <MobileMonthlyDay day={day} />
          </div>
        ))
      ) : (
        <div data-hook="calendar-empty" className={classNames(s.empty, sc.textLineHeight)}>
          {t('layout.calendar.monthly.empty')}
        </div>
      )}
    </div>
  )
}
